export { default } from './VideoClipSection';
